import React from 'react';
import { Close } from 'ceicons';
import classnames from 'classnames';

import './Sidebar.scss';

export default function Sidebar(props) {
  const { expanded, setExpanded, isFixed, title, children } = props;

  return (
    <div className={classnames('sidebar', { isFixed, expanded })}>
      <div className={classnames('sidebar__menu', { expanded })}>
        <div className="sidebar__menu-header">
          <h5>{title}</h5>
          <Close onClick={() => setExpanded(false)} />
        </div>
        <div className="sidebar__menu-content">{children}</div>
      </div>
    </div>
  );
}
